import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import * as Sentry from '@sentry/react';
import { SLICES } from '../constants/slices';
import { CSPRouterProvider } from './CSPRouterProvider';
import { FeatureFlagContextProvider } from '../contextProviders/featureFlagContext';
import { getGtmService } from '../services/gtmService/GtmService';

export const CSPRoutes = () => {
  const { authDetails } = useSelector((state) => state?.[SLICES.AUTHENTICATION]);

  useEffect(() => {
    if (!authDetails?.contactId) {
      Sentry.setUser(null);
      return;
    }

    // allow Sentry to track the user contact id for monitoring and debugging purposes
    Sentry.setUser({ id: authDetails.contactId });
    const gtm = getGtmService();
    gtm.pushSetUserProperties(authDetails.contactId, 'CSP3');
  }, [authDetails?.contactId]);

  return (
    <FeatureFlagContextProvider>
      <CSPRouterProvider />
    </FeatureFlagContextProvider>
  );
};
